export default __webpack_public_path__ + "static/media/08-jorge-valdano-b@3x.44644719.png";